import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import { hasPermission } from 'helpers/permissions';

interface PermissionButtonProps extends ButtonProps {
  allowedRoles: string[];
  fallback?: React.ReactNode;
}

/**
 * Button component that only renders if user has permission
 * @param allowedRoles - Array of roles that are allowed to see the button
 * @param fallback - Optional component to render if user doesn't have permission (default: null)
 * @param ...rest - All other Button props from Material-UI
 */
const PermissionButton: React.FC<PermissionButtonProps> = ({
  allowedRoles,
  fallback = null,
  ...rest
}) => {
  const hasAccess = hasPermission(allowedRoles);

  if (!hasAccess) {
    return <>{fallback}</>;
  }

  return <Button {...rest} />;
};

export default PermissionButton;

